import * as bootstrap from 'bootstrap'
import EditorJS from "@editorjs/editorjs";
import Header from '@editorjs/header';
import Paragraph from '@editorjs/paragraph';
import Quote from "@editorjs/quote";
import $ from 'jquery';
import TrueCropper from 'truecropper';
import 'truecropper/dist/truecropper.css';

export function debounce(func, wait, immediate) {
	let timeout;
	if (!wait) {
		wait = 250;
	}
	return function () {
		const context = this, args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(function () {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		}, wait);
		if (immediate && !timeout) {
			func.apply(context, args);
		}
	};
}

export function noEnter(evt) {
	let theEvent = evt || window.event;

	let key;
	if (theEvent.type !== 'paste') {
		key = theEvent.keyCode || theEvent.which;
		if (key === 13) {
			theEvent.preventDefault();
			$(this).blur();
			return;
		}
		String.fromCharCode(key);
	}
}

function setSaveStatus(disable = false) {
	if (window.saveEnabled !== true && !disable) {
		const saveButton = document.getElementById('save');
		saveButton.disabled = false;
		saveButton.classList.remove('disabled');
		window.addEventListener('beforeunload', function (e) {
			if (window.saveEnabled && !window.saveClicked) {
				const confirmationMessage = 'You have unsaved changes. Are you sure you want to leave?';
				(e || window.event).returnValue = confirmationMessage; // Gecko + Webkit, Safari, Chrome
				return confirmationMessage; // Gecko + Webkit, Safari, Chrome
			}
		});
		window.saveEnabled = true;
	} else if (disable) {
		const saveButton = document.getElementById('save');
		saveButton.disabled = true;
		saveButton.classList.add('disabled');
		window.saveEnabled = false;
	}
}

export function setChecksum() {
	const checksum = document.getElementById('checksum');
	checksum.value = hashCode(JSON.stringify(data[0].blocks));
}

export function startEditor(data) {
	const editor = new EditorJS({
		holder: 'editorjs',
		data: data[0] ?? data,
		tools: {
			header: {
				class: Header,
				inlineToolbar: true,
				config: {
					placeholder: 'Header',
					levels: [1, 2, 3],
					defaultLevel: 2
				}
			},
			paragraph: {
				class: Paragraph,
				inlineToolbar: true,
				config: {
					placeholder: 'Type something here...'
				}
			},
			quote: {
				class: Quote,
				inlineToolbar: true,
				config: {
					placeholder: 'Quote',
					withTextAlignment: true,
				}
			},
		},
		onChange(api, event) {
			const dataField = document.getElementById('data');
			const checksum = document.getElementById('checksum');
			api.saver.save().then((blocks) => {
				dataField.value = JSON.stringify(blocks);
				const isAltered = hashCode(JSON.stringify(blocks.blocks)) !== parseInt(checksum.value);
				if (!isAltered) {
					setSaveStatus(true);
				}
				if (window.saveEnabled !== true && isAltered) {
					setSaveStatus();
				}
//				console.log(hashCode(JSON.stringify(blocks.blocks)));
			});
		}
	});
}

export function activateTooltips() {
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}

export function updateData(initial = false) {
	const checksum = document.getElementById('checksum');
	const dataField = document.getElementById('data');
	const datas = {};
	const newData = [];
	const $inputs = $("#sortable input");
	switch (cmd) {
		case "meta":
			$inputs.each(function () {
				const fld = $(this).attr("id").split("_")[0];
				const id = $(this).attr("id").split("_")[1];
				if (!datas.hasOwnProperty(fld)) {
					datas[fld] = "";
				}
				datas[fld] = $(this).val();
			});
			dataField.value = JSON.stringify(datas);
			break;
		case "news":
			dataField.value = JSON.stringify(window.news);
			break;
		case "main":
			dataField.value = JSON.stringify(window.main);
			break;
		case "dsps":
			$inputs.each(function () {
				const fld = $(this).attr("id").split("_")[0];
				const id = $(this).attr("id").split("_")[1];
				if (!datas.hasOwnProperty(id)) {
					datas[id] = {
						title: "",
						url: "",
					};
				}
				datas[id][fld] = $(this).val();
			});
			dataField.value = JSON.stringify(datas);
			break;
		case "gallery":
			$inputs.each(function () {
				const id = "el_" + $(this).attr("id").split("_")[1];
				const fld = $(this).attr("id").split("_")[0];
				if (!datas.hasOwnProperty(id)) {
					datas[id] = {
						file: "",
						caption: "",
					};
				}
				datas[id][fld] = $(this).val();
			});
			for (const [key, value] of Object.entries(datas)) {
				newData.push(value);
			}
			dataField.value = JSON.stringify(newData);
			break;
		case "contacts":
			$inputs.each(function () {
				const fld = $(this).attr("id").split("_")[0];
				const id = "el_" + $(this).attr("id").split("_")[1];
				if (!datas.hasOwnProperty(id)) {
					datas[id] = {
						title: "",
						text: "",
						email: "",
						www: "",
					};
				}
				datas[id][fld] = $(this).val();
			});
			for (const [key, value] of Object.entries(datas)) {
				newData.push(value);
			}
			dataField.value = JSON.stringify(newData);
			break;
		case "tour":
			$inputs.each(function () {
				const fld = $(this).attr("id").split("_")[0];
				const id = "el_" + $(this).attr("id").split("_")[1];
				if (!datas.hasOwnProperty(id)) {
					datas[id] = {
						date: "",
						country: "",
						city: "",
						arena: "",
						releasedat: 0,
						link: "",
						soldout: 0,
					};
				}
				if (fld === "soldout") {
					datas[id][fld] = $(this).is(":checked") ? 1 : 0;
				} else {
					datas[id][fld] = $(this).val();
				}
			});
			for (const [key, value] of Object.entries(datas)) {
				newData.push(value);
			}
			dataField.value = JSON.stringify(newData);
			break;
	}
	if (initial) {
		checksum.value = hashCode(dataField.value);
	} else {
		const isAltered = hashCode(dataField.value) !== parseInt(checksum.value);
		if (!isAltered && !window.isVersion) {
			setSaveStatus(true);
		}
		if (window.saveEnabled !== true && isAltered) {
			setSaveStatus();
		}
	}
}

export function addEventListeners(target) {
	let items = target.getElementsByTagName("input");
	for (let i of items) {
		i.addEventListener("keydown", noEnter);
		if (i.hasAttribute("type") && i.type === "checkbox") {
			i.addEventListener("change", debounce(() => {
				updateData();
			}, 100));
		} else {
			i.addEventListener("input", debounce(() => {
				updateData();
			}, 350));
		}
	}
	items = target.getElementsByClassName("remover");
	for (let i of items) {
		i.addEventListener("click", function () {
			if (confirm("Are you sure you want to delete this item?")) {
				const parent = this.parentNode;
				parent.parentNode.removeChild(parent);
				updateData();
			}
		});
	}
}

export function sList(target, tag = "li") {
	target.classList.add("sList");
	let items = target.getElementsByTagName(tag), current = null;
	for (let i of items) {
		if (i.hasAttribute("id")) {
			i.draggable = true;
			i.ondragstart = e => {
				current = i;
				for (let it of items) {
					if (it === current) {
						it.classList.add("moving");
					}
				}
			};
			i.ondragend = () => {
				let idx = 0;
				for (let it of items) {
					if (it.hasAttribute("id")) {
						idx++;
						it.classList.remove("moving");
					}
				}
				updateData();
			};
			i.ondragover = e => e.preventDefault();
			i.ondrop = e => {
				e.preventDefault();
				if (i !== current) {
					let currentPos = 0, droppedPos = 0;
					for (let it = 0; it < items.length; it++) {
						if (current === items[it]) {
							currentPos = it;
						}
						if (i === items[it]) {
							droppedPos = it;
						}
					}
					if (currentPos < droppedPos) {
						i.parentNode.insertBefore(current, i.nextSibling);
					} else {
						i.parentNode.insertBefore(current, i);
					}
				}
			};
		}
	}
}

export function deList(target, tag = "li") {
	target.classList.remove("sList");
	let items = target.getElementsByTagName(tag), current = null;
	for (let i of items) {
		i.draggable = false;
	}
}

export function hashCode(s) {
	let h;
	for (let i = 0; i < s.length; i++)
		h = Math.imul(31, h) + s.charCodeAt(i) | 0;

	return h;
}

export function addRow() {
	let rowTemplate = "";
	switch (cmd) {
		case "contacts":
			rowTemplate = `<tr class="templateRow" id="sorter-*id*"><th class="grip pt-2"><i class="fa fa-grip-dots-vertical"></i></th><td><input type="text" id="title_*id*" class="form-control form-control-sm w-100"></td><td><input type="text" id="text_*id*" class="form-control form-control-sm w-100"></td><td><input type="email" id="email_*id*" class="form-control form-control-sm w-100"></td><td><input type="url" id="www_*id*" class="form-control form-control-sm w-100"></td><td><input type="tel" id="phone_*id*" class="form-control form-control-sm w-100"></td><td class="remover" data-for="sorter-*id*"><i class="fa fa-trash-alt text-danger mt-2 pointer"></i></td></tr>`;
			break;
		case "tour":
			rowTemplate = `<tr class="templateRow" id="sorter-*id*"><td class="date"><input type="date" id="date_*id*" class="form-control form-control-sm"></td><td><input type="text" id="country_*id*" class="form-control form-control-sm w-100"></td><td><input type="text" id="city_*id*" class="form-control form-control-sm w-100"></td><td><input type="text" id="arena_*id*" class="form-control form-control-sm w-100"></td><td><input type="url" id="link_*id*" class="form-control form-control-sm w-100"></td><td class="datetime"><input type="datetime-local" id="releasedat_*id*" class="form-control form-control-sm"></td><td class="d-flex justify-content-center"><div class="form-check mt-1 text-center ps-0"><input type="checkbox" id="soldout_*id*" class="form-check" value="1"></div></td><td class="remover" data-for="sorter-*id*"><i class="fa fa-trash-alt text-danger mt-2 pointer"></i></td></tr>`;
			break;
	}
	const nextId = $('#sortable tbody tr').length;
	let html = rowTemplate.replace(/\*id\*/g, nextId);
	$("#sortable tbody").append(html);
	if (cmd === "contacts") {
		const items = document.getElementById("sortable");
		sList(items, "tr");
	}
	addEventListeners(document.getElementById(`sorter-${nextId}`));
}

const modal = document.getElementById('modal');
const modalImg = document.getElementById('modal-img');
const modalCaption = document.getElementById('modal-caption');

export function checkEscape(event) {
	if (event.key === 'Escape') {
		closeModal();
	}
}

export function openModal(src, caption = "") {
	modal.style.display = 'flex';
	if (!src.includes("img/org/")) {
		modalImg.src = src.replace("img/", "img/org/");
	} else {
		modalImg.src = src;
	}
	modalCaption.innerHTML = caption;
	modalImg.blur();
	document.addEventListener('keydown', checkEscape);
}

export function closeModal() {
	modal.style.display = 'none';
	document.removeEventListener('keydown', checkEscape);
}

export function initGallery() {
	document.querySelectorAll('.gallery img').forEach(function (img) {
		img.addEventListener('click', function (event) {
			openModal(event.target.src, event.target.alt);
		});
	});

	modal.addEventListener('click', function () {
		closeModal();
	});
}

export function initCropper() {
	const cropper = new TrueCropper("#previewImage", {
		aspectRatio: 24 / 21,
		returnMode: 'real',
	});
	const cropBtn = document.getElementById("cropBtn");
	const dimensions = document.getElementById("dimensions");
	window.cropper = cropper;

	cropBtn.addEventListener("click", function () {
		dimensions.value = JSON.stringify(cropper.getValue());
	});
}

export function attachRemoveListener() {
	let items;
	const form = document.querySelector("#remove-from-gallery");
	const removeField = document.querySelector("#remover");
	items = document.getElementsByClassName("remove-button");
	for (let i of items) {
		i.addEventListener("click", function () {
			removeField.value = this.getAttribute("data-file");
			form.submit();
		});
	}
}

export function checkPast() {
	const checkBox = document.getElementById("hide_past");
	if (checkBox === null) {
		return;
	}
	checkBox.checked = localStorage.getItem("hide_past") === 'true';
	if (checkBox.checked) {
		document.querySelector("body").classList.add("hide-past");
	} else {
		document.querySelector("body").classList.remove("hide-past");
	}
	checkBox.addEventListener("click", function () {
		localStorage.setItem("hide_past", this.checked);
		if (this.checked) {
			document.querySelector("body").classList.add("hide-past");
		} else {
			document.querySelector("body").classList.remove("hide-past");
		}
	});
}
